import { render, staticRenderFns } from "./TabsModal.vue?vue&type=template&id=07a36404&scoped=true&"
import script from "./TabsModal.vue?vue&type=script&lang=js&"
export * from "./TabsModal.vue?vue&type=script&lang=js&"
import style0 from "./TabsModal.vue?vue&type=style&index=0&id=07a36404&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a36404",
  null
  
)

export default component.exports